// The Google Ads click id and utm_* tags on the current URL, sent with the
// order (use-orders-api.js) so the draft carries them before Stripe is
// involved. The booking flow keeps the landing query string across steps
// (services/history.js), so on /booking/... they are still the landing ones.
// The server also has them in first-party cookies (app/services/ad_click.rb),
// which cover a visitor who wandered off the tagged URL; it validates both.
// Imports nothing, so node --test can run it (ad-click.test.mjs).
// docs/GOOGLE_ADS.md

export const AD_CLICK_KEYS = ['gclid', 'gbraid', 'wbraid', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content']

export const adClickParams = (search = typeof window === 'undefined' ? '' : window.location.search) => {
  const query = new URLSearchParams(search || '')
  const out = {}
  for (const key of AD_CLICK_KEYS) {
    const value = query.get(key)
    if (value) out[key] = value.slice(0, 200)
  }
  return out
}
